export default __webpack_public_path__ + "static/media/dallas.79e08ed5.png";